import { useRef, memo } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { TagsInput, MemberMultiSelectDropdown } from '../common';

const AddMembers = ({ handleListUpdate, teamList }) => {
  const sortedMembersList = teamList;
  const existingTeamMembers = [];
  const newTeamMembers = [];
  const selectInputRef = useRef(null);
  const tagsInputRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && event.shiftKey === false) {
      event.preventDefault();
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        addExistingTeamMembers: existingTeamMembers,
        addNewTeamMembers: newTeamMembers,
      }}
      onSubmit={(values, { resetForm }) => {
        handleListUpdate(values);
        resetForm();
        // Clear input values
        selectInputRef.current.select.clearValue();
        tagsInputRef.current.select.select.clearValue();
      }}
    >
      {(formikprops) => (
        <Form
          onSubmit={formikprops.handleSubmit}
          onKeyDown={(e) => {
            handleKeyDown(e);
          }}
        >
          <section>
            <MemberMultiSelectDropdown
              id="selectInputRef"
              name="addExistingTeamMembers"
              labelText="Add existing Team Members"
              fromArray={sortedMembersList}
              formProps={formikprops}
              isDisabled={sortedMembersList.length < 1 && true}
              innerRef={selectInputRef}
            />
            <TagsInput
              id="tagInputRef"
              name="addNewTeamMembers"
              labelText="Add new Team Members"
              placeHolderText="Type email address and press enter"
              formProps={formikprops}
              innerRef={tagsInputRef}
            />
          </section>

          <div className="d-flex justify-content-end align-items-center my-5">
            <Button
              type="submit"
              className="btn btn-primary"
              disabled={!(formikprops.isValid && formikprops.dirty)}
            >
              Add Member Report{' '}
              {formikprops.isSubmitting && (
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

AddMembers.propTypes = {
  handleListUpdate: PropTypes.func,
  teamList: PropTypes.array,
};

export default memo(AddMembers);
